/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

<template>

  <div class="login">

    <div id="okta-signin-container"></div>
      
      <div class="ui one column stackable center aligned page grid">
   <div class="column twelve wide">
        <a class="big ui animated button gray " v-if="this.portal" v-bind:href="this.portal">
          <div class="visible content">Back to Application</div>
          <div class="hidden content"><i class="left arrow icon"></i></div>
        </a>
   </div>
   <div v-bind:style="debugStyle">{{id}}<br>{{portal}}</div>
</div>
       
      
  </div>
  
</template>

<script>
import OktaSignIn from '@okta/okta-signin-widget'
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css'

import sampleConfig from '../config'

export default {
  name: 'Login',
  data: function () {
    var id = "";
    var portal = "";
    var stage = "";
    var phone = "";
    var fountainInfo = null;

    id = this.$route.query.id;
    portal = this.$route.query.portal;
    stage = this.$route.query.stage;
    phone = this.$route.query.phone;

    
    if (localStorage.getItem("fountain-info") !== null) {
    fountainInfo = JSON.parse(localStorage["fountain-info"]);
    console.log("Previous Fountain ID Detected")
      if (fountainInfo.expiration < new Date().getTime()){
        console.log("Fountain ID Expired")
        localStorage.removeItem("fountain-info")
        fountainInfo = null;
      }
      if (!id){
        id = fountainInfo.id;
      }
      if (!portal){
        portal = fountainInfo.portal;
      }
    }

    return {
      id: id,
      portal: portal,
      stage: stage,
      phone: phone,
      fountainInfo:fountainInfo,
      debugStyle:{
        color: 'lightgrey',
        fontSize: '10px',
        textAlign: 'center'
        }
      }
  },
  mounted: function () {
    this.loginCheck();
    this.$nextTick(function () {
      if (this.$route.query.phone == null){ 
          console.log("No application phone provided in query")
      } else {
          localStorage.setItem("phone", this.phone);
      }
      if (this.$route.query.id == null && this.$route.query.portal == null){ 
          console.log("No application id provided in query")
        } else{
        localStorage.setItem("fountain-info",JSON.stringify({
        "id":this.id, 
        "portal":this.portal, 
        "stage":this.stage,
        "expiration": new Date().getTime() + 3600}));
        }
      this.widget = new OktaSignIn({
        /**
         * Note: when using the Sign-In Widget for an OIDC flow, it still
         * needs to be configured with the base URL for your Okta Org. Here
         * we derive it from the given issuer for convenience.
         */
        baseUrl: sampleConfig.oidc.issuer.split('/oauth2')[0],
        clientId: sampleConfig.oidc.clientId,
        redirectUri: sampleConfig.oidc.redirectUri,
        // eslint-disable-next-line no-undef
        logo: require('@/assets/logo.png'),
        i18n: {
          en: {
            'primaryauth.title': 'Sign in to Liveops Nation'
          }
        },
        authParams: {
          pkce: true,
          issuer: sampleConfig.oidc.issuer,
          display: 'page',
          scopes: sampleConfig.oidc.scopes
        }
      })

      this.widget.renderEl(
        { el: '#okta-signin-container' },
        () => {
          /**
           * In this flow, the success handler will not be called because we redirect
           * to the Okta org for the authentication workflow.
           */
        },
        (err) => {
          throw err
        }
      )
    })
  },
  destroyed () {
    // Remove the widget from the DOM on path change
    this.widget.remove()
  },
  methods: {
      async loginCheck() {
        this.claims = await this.$auth.getUser()
        if (this.claims) {
          if (this.$route.query.forcelogout == "true") {
            await this.$auth.logout();
            console.log("force logged out");
            window.location = "/login";
          } else {
            window.location = "/";
            console.log("logged in");
          }
        }
      }
    }
  }

</script>
